export default "__VITE_ASSET__1a9b869c__"